// extracted by mini-css-extract-plugin
module.exports = {"marker":"_3EvT8Z","hover":"_3-B7OJ","selected":"_3hDZC4","label":"i2CfQi","oslo":"_3CinnZ"};